import api from "./client";

export const getOptions = (params) => api.get("/options", { params });
export const getOptionStatusCounts = () => api.get("/options/status-counts");
export const getOption = (optionId) => api.get(`/options/${optionId}`);
export const createOption = (data) => api.post("/options", data);
export const updateOption = (optionId, data) => api.patch(`/options/${optionId}`, data);
export const updateOptionStatus = (optionId, status, { send_decline_email, rejection_reason, rejection_notes } = {}) =>
  api.patch(`/options/${optionId}/status`, null, { params: { status, ...(send_decline_email !== undefined && { send_decline_email }), ...(rejection_reason && { rejection_reason }), ...(rejection_notes && { rejection_notes }) } });
export const deleteOption = (optionId) => api.delete(`/options/${optionId}`);
// Per-user "seen" marks behind the NEW option tag.
export const getMySeenOptions = () => api.get("/option-views/mine");
export const markOptionsSeen = (optionIds) => api.post("/option-views/seen", { option_ids: optionIds });
